module.exports = __webpack_public_path__ + "img/message-icon.a2065628.svg";